// Resham Bazaar Premium Collections Page Controller

(function() {
  function initCollectionsPage(root = document) {
    const page = root.matches?.('.rb-collections-page') ? root : root.querySelector('.rb-collections-page');
    if (!page || page.dataset.rbCollectionsReady === 'true') return;

    const filterPills = page.querySelectorAll('[data-rb-filter]');
    const collectionCards = page.querySelectorAll('[data-rb-collection-card]');
    const gridEmpty = page.querySelector('[data-rb-grid-empty]');
    const activeFilterLabel = page.querySelector('[data-rb-active-filter]');

    if (collectionCards.length === 0) return;
    page.dataset.rbCollectionsReady = 'true';

    const updateFilterStatus = (label) => {
      if (activeFilterLabel) activeFilterLabel.textContent = label;
    };

    updateFilterStatus('All collections');

    // 1. Category Filtering Logic
    filterPills.forEach(pill => {
      pill.addEventListener('click', () => {
        const filterValue = pill.getAttribute('data-rb-filter');

        // Toggle active class on pills
        filterPills.forEach(p => {
          p.classList.remove('is-active');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-pressed', 'true');

        let visibleCount = 0;

        // Class-based filtering is reliable across theme-editor rerenders and
        // does not leave old inline display/opacity values on cards.
        collectionCards.forEach(card => {
          const categories = (card.getAttribute('data-categories') || '')
            .split(',')
            .map(category => category.trim().toLowerCase());
          const matches = filterValue === 'all' || categories.includes(filterValue.toLowerCase());

          card.classList.toggle('is-filtered-out', !matches);
          if (matches) visibleCount++;
        });

        if (gridEmpty) {
          gridEmpty.style.display = visibleCount === 0 ? 'block' : 'none';
          gridEmpty.style.opacity = visibleCount === 0 ? '1' : '0';
        }

        updateFilterStatus(pill.textContent.trim());
      });
    });

    // 2. Scroll Intersection Observer for entrance animations
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      // Respect user's motion preference: instantly show all cards
      collectionCards.forEach(card => card.classList.add('is-visible'));
      return;
    }

    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -60px 0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries, self) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const card = entry.target;
          card.classList.add('is-visible');
          self.unobserve(card); // Stop observing once animated in
        }
      });
    }, observerOptions);

    collectionCards.forEach((card, index) => {
      // Delay observation triggers slightly for staggered card loads on first viewport
      setTimeout(() => {
        observer.observe(card);
      }, index * 60);
    });
  }

  // Document Ready and Shopify Theme customizer listeners
  document.addEventListener('DOMContentLoaded', () => initCollectionsPage(document));

  // Re-run scripts if section is loaded inside theme customizer editor
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.rb-collections-page')) {
      initCollectionsPage(event.target);
    }
  });
})();
